module.exports = __webpack_public_path__ + "static/media/pop-up.9d040cae.png";